<template lang='pug'>
  v-container.pa-0
    //- Taxes dialog
    v-dialog(v-model='showtaxesDialog' :fullscreen="isMobile" scrollable='' max-width='400px')
      taxes-dialog(@Close="showtaxesDialog=false")
    v-snackbar(v-model='snackbar',  color="red" center top  :timeout="6000")
      | {{ message }}
      v-btn(dark='', text='', @click='snackbar = false')
        | Cerrar
    v-row
      p Los campos con
          p.red--text.ml-2.mr-2 *
      p son obligatorios
    //- Create
    v-row(v-if="hideButtons")
      //- Tipo de unidad
      v-col(cols="12" v-if="model.magnitude")
        v-select(:items="unitsOptions" v-model='model.unit')
          template(v-slot:label)
            span() Unidad
            span.red--text() *
      //- Qty al mayor
      v-col(cols="5")
        v-text-field( :rules="[rules.minValue, rules.twoDecimals]" type="text" @input="replaceComma(model, 'wholesale')" label='Cantidad al por mayor', v-if='model.price' v-model='model.price.wholesale.amount',)
      v-col(cols="5")
        v-text-field(type='number' label='Valor', :rules="[rules.minValue, rules.maxValue]" v-if='model.price' v-model='model.price.wholesale.price', :prefix="model.price.wholesale.percentage ? '' : '$'")
      v-col(cols="2")
        v-checkbox(label="%" v-model="model.price.wholesale.percentage")
      //- Total venta
      v-col(cols="12")
        v-text-field(disabled type='number' label='Total Venta', v-if='model.price'  v-model='model.price.sale', prefix='$')
    //- Update
    v-row(v-else)
      v-col(cols="12" xs="12" sm="5" md="5")
        //- Image
        v-col.text-center(cols="auto" style="max-height: 200px; overflow:hidden;")
          input.d-none(ref="file" type="file" @change="handleImageUpload($event, 1)" accept="image/*")
          v-card.pa-1.mx-auto.mt-0.d-inline-flex.v-card--account(:class="model.pictures && !model.pictures.imageInput1 ? 'background-image-container' : ''" height="180" width="180" @click="$refs.file.click()")
            v-img(contain v-if='model.pictures && model.pictures.imageInput1' :src="model.pictures.imageInput1" height="180" width="100%")
            v-icon.mx-auto.white--text(v-else="" size="50") mdi-camera
        //- Images
        v-col.text-center(cols="12"  v-if="model.type != 'ingredient'")
          input.d-none(ref="file2"  type="file" @change="addImageToModel($event)" accept="image/*")
          v-btn.main-btn-grey(:disabled="totalImagesModel == 0" small @click="$refs.file2.click()")
            .mx-2 Imagenes alternativas
        //- Images
        v-col.text-center.px-1(v-for="(image, index) in imagesModel" cols="auto" :style="image !== '' ? 'max-height: 200px; overflow:hidden;display: inline-grid;': 'max-height: 200px; overflow:hidden;display: inline-grid;display: none !important' ")
          v-card.pa-1.mb-1.mx-auto.mt-0.d-inline-flex.v-card--account.success--text( outlined="" height="75" width="75" )
            img(:id="index" :src="image" contain style="height: 60; width: 100%; cursor: pointer;" @click="openImage(image)")
            v-btn(style=" position: absolute; top: -20px; right: -20px;" text icon color="red")
              v-icon.font-weight-bold(dark @click="deleteImageModel(index)" size="20")
                | mdi-close
        //- Alerts
        v-row.mt-1(v-if="model.type")
          v-col(cols="6")
            v-text-field.xs3(:disabled="!lowStock" label='Cantidad' v-model='model.lowStockAlert'  :rules='[rules.required, rules.twoDecimals]'  type="number")
          v-col(cols="6")
            v-card(color="#c0d1d5cc" height="70" width="160" elevation="0")
              v-row
                v-col.py-0(cols="3")
                  v-checkbox( v-model="lowStock")
                v-col.d-flex.justify-center.flex-column(cols="9" style="font-size: 13px; color: #8da4a9")
                  p.alert-title Alertas
                  p Inventario bajo
        v-row.mt-1(v-if="model.type")
          v-col(cols="6")
            p Aprobar por cocina
          v-col(cols="6")
            v-checkbox(label="Requiere aprobación de cocina" v-model="kitchenAprobal")

      v-col(cols="12" xs="12" sm="7" md="7")
        //- Unidad
        v-col(cols="12" v-if="model.magnitude")
          v-select(:items="unitsOptions" v-model='model.unit')
            template(v-slot:label)
              span() Unidad
              span.red--text() *
        //- Name
        v-text-field(type="text" prepend-inner-icon="mdi-tag" :rules="[rules.nameRules]" v-model='model.name' counter="100")
          template(v-slot:label)
            span() Nombre del producto
            span.red--text() *
        //- Description
        v-text-field(prepend-inner-icon="mdi-file-document" v-model="model.description" counter="150" :rules="[rules.descriptionRules]")
          template(v-slot:label)
            span() Descripción
        //- Comprar y venta
        v-row
          //- Compra
          v-col(cols='6')
            v-text-field(type='text' v-if='model.price' v-model='model.price.buy', prepend-inner-icon="mdi-hand-coin")
              template(v-slot:label)
                span() Compra
                span.red--text()
          //- Venta
          v-col(cols='6')
            v-text-field(@change="changeValTaxes" type='number' v-if='model.price && context==="posts"'  v-model='model.price.salewithouttax', prepend-inner-icon="mdi-hand-coin")
              template(v-slot:label)
                span() Precio de venta genérico
                span.red--text() *
            v-text-field(@change="changeValTaxes" type='number' v-else-if="model.price.salewithouttax"  v-model='model.price.salewithouttax', prepend-inner-icon="mdi-hand-coin")
              template(v-slot:label)
                span() Precio de venta genérico
                span.red--text() *
            v-text-field(@change="changeValTaxes" type='number' v-else  v-model='model.price.sale', prepend-inner-icon="mdi-hand-coin")
              template(v-slot:label)
                span() Precio de venta genérico
                span.red--text() *
        //- Taxes
        v-row
          v-col.py-0(cols='6')
            v-select(@change="changeValTaxes" v-model='model.taxesLstProduct', :items='lstTaxes', return-object  item-text="data.name" label='Impuestos', multiple='', small-chips='')
          v-col.py-0.d-flex.justify-center.align-center(cols='6')
            v-btn.main-btn-grey(small @click="showtaxesDialog = true")
              .mx-2
                v-icon mdi-plus
                | Crear Impuesto
        //- Categorias
        v-row
          v-col.py-0(cols='6')
            v-select(v-model='model.categories', :items='field.categories', return-object multiple item-text='name')
              template(v-slot:label)
                span() Seleccionar
                span.red--text() *
          v-col.py-0.d-flex.justify-center.align-center(cols='6')
            v-btn.main-btn-grey(small @click="$emit('openCategoryModal')")
              .mx-2
                v-icon mdi-plus
                | Crear Subcategoria
        //- Total
        v-text-field(disabled type='number' label='Total Venta', v-if='model.price'  v-model='model.price.sale', prefix='$')
      v-col.mt-1(cols="12")
        //- Qty al mayor
        v-row
          v-col(cols="5")
            v-text-field( :rules="[rules.minValue, rules.twoDecimals]" type="text" @input="replaceComma(model, 'wholesale')" label='Cantidad al por mayor', v-if='model.price' v-model='model.price.wholesale.amount',)
          v-col(cols="5")
            v-text-field(type='number' label='Valor', :rules="[rules.minValue, rules.maxValue]" v-if='model.price' v-model='model.price.wholesale.price', :prefix="model.price.wholesale.percentage ? '' : '$'")
          v-col(cols="2")
            v-checkbox(label="%" v-model="model.price.wholesale.percentage")
        //- Tiendas
        .text-center(style="display:flex; align-items:center;")
          v-chip-group(v-model="tempLocations" column="" multiple="")
            v-chip(filter="" outlined="" v-for="item in field.locations" :value = 'item'  :disabled ='disableChip(item)')
              v-avatar(left="")
                v-img(:src="item.image")
              |  {{item.name}}
        //- Precios tienda
        v-col.xs12.mt-4.px-2.column( style="max-height: 300px; overflow-y: auto;")
          v-flex.xs12.purchase-form__input(v-if='tempLocations' style='display:flex; ' v-for="(item, index) in tempLocations" :key="index" )
            v-text-field.xs6( style='font-size: 10px;' disabled label='tienda'  type="text", v-model='item.name')
            v-text-field.xs3(type="number" :rules="[rules.numberRule, rules.number]" v-model='item.stock')
              template(v-slot:label)
                span() Cantidad
                span.red--text() *
            v-text-field.xs3(v-if="model.magnitude" label="Unidad" disabled :value="model.unit")
            v-text-field.xs3(@change="changeValTaxesModel(item)" type='number' v-if='item.price && context==="posts"'  v-model='item.pricewithouttax', prefix='$')
              template(v-slot:label)
                span() Precio de venta
                span.red--text() *
            v-text-field.xs3(@change="changeValTaxesModel(item)" type='number' v-else-if="item.pricewithouttax"  v-model='item.pricewithouttax', prefix='$')
              template(v-slot:label)
                span() Precio de venta
                span.red--text() *
            v-text-field.xs3(@change="changeValTaxesModel(item)" type='number' v-else  v-model='item.price', prefix='$')
              template(v-slot:label)
                span() Precio de venta
                span.red--text() *
            v-text-field.xs3(disabled label='Precio de venta Total'  type="number", v-model='item.price' prefix ='$')
    //- Update
    .text-center(v-if='!hideButtons')
      v-btn(@click="cancel()") Cancelar
      v-btn(color='#008e95' @click='save' :loading="saveLoading" :disabled='invalidForm(model)')
        | GUARDAR

</template>
<script>
  import Preview from '../preview/ProductPreview'
  import * as firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  import TaxesDialog from '@/components/custom/dialogs/TaxesDialog'
  // import Quagga from '@ericblade/quagga2'
  import Swal from 'sweetalert2'

  export default {

    components: {
      Preview: Preview,
      TaxesDialog: TaxesDialog,
    },
    props: {
      model: Object,
      magnitude: Number,
      field: Object,
      context: String,
      hideButtons: Boolean,
      onSave: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        lowStock: false,
        kitchenAprobal: false,
        rules: {
          required: value => !!value || 'Ingresar la cantidad',
          twoDecimals: value => /^[0-9]+(\.[0-9]{1,2})?$/.test(value) || 'Maximo dos decimales',
          number: value => {
            return /^[0-9]+([,.][0-9]+)?$/g.test(value) || 'Cifra invalida.'
          },
          minValue: value => {
            return value >= 1 || 'Valor minimo debe ser igual a 1'
          },
          descriptionRules: value => {
            return value.length < 151 || 'Maximo 150 caracteres'
          },
          nameRules: value => {
            return (!!value && value.length > 0 && value.length < 101) || 'Nombre del producto debe estar entre 0 y Maximo 100 caracteres'
          },
          maxValue: value => {
            return this.validateValue() || 'El valor no debe superar el precio de venta general'
          },
          numberRule: v => (!isNaN(parseFloat(v)) && v >= 0) || 'La cantidad debe ser mayor que 0',
        },
        changeTaxesValue: true,
        showtaxesDialog: false,
        timeoutTaxes: null,
        taxesLstProduct: null,
        saveLoading: false,
        tempLocations: [],
        valueType: '',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
        toggle_exclusive: 2,
        imagesModel: ['', '', '', ''],
        actionsImagesModel: [],
        totalImagesModel: 4,
        message: '',
        snackbar: false,
        isDragging: false,
        freeSpaces: 0,
      }
    },
    computed: {
      unitsOptions () {
        const vm = this
        if (vm.model.magnitude === 1) {
          return ['gr', 'kg', 'lb', 'ton', 'ml', 'lt', 'gal', 'cm3', 'cm', 'mt', 'mt2']
        }
        return []
      },
      lstTaxes () {
        // console.log(this.$store.state.users.taxes)
        return this.$store.state.users.taxes
      },
      categories () {
        return this.model.categories
      },

      user () {
        return this.$store.state.users.user
      },
      sliderValue () {
        return this.slider
      },
      loading () {
        return this.$store.getters.getLoading
      },
      changeTaxesValueComputed () {
        return this.changeTaxesValue
      },
    },
    watch: {
      lowStock (newValue, oldValue) {
        const vm = this
        if (vm.model.lowStockAlert && !vm.lowStock) {
          vm.model.lowStockAlert = 0
        }
        // console.log(vm.model)
      },
      categories (newValue, oldValue) {
        // console.log('Categorias en producto: ', newValue)
        // console.log('todos los lugares', this.field.locations)
        // console.log('el modelo del producto', this.model)
        //
        // const places = this.field.locations
        // const currentCategories = newValue
        // const model = this.model

        try {
          // this.populateFields(places, currentCategories, model)
          // // console.log(model)
          // Cuando se escoje una categoria, se debe buscar en la lista de lugares, cuales tienen esa categoria

          // al encontrar los lugares, se deben agregar al modelo
        } catch (err) {
          // console.log(err)
        }
      },
      async 'model.taxesLstProduct' (newVal, oldVal) {
        const vm = this
        // console.log(newVal, oldVal)
        if (newVal !== oldVal) {
          // console.log('cambio')
          vm.changeTaxesValue = await true // se agrego o elimino impuestos a el producto
          vm.model.taxesChanged = true
          for await (const loc of vm.tempLocations) {
            vm.changeValTaxesModel(loc)
          }
        }
      },
    },
    created () {
      const vm = this
      if (vm.model.kitchenAprobal !== undefined) {
        vm.kitchenAprobal = vm.model.kitchenAprobal
      } else {
        vm.kitchenAprobal = false
      }
      if (!vm.model.description) {
        vm.model.description = ''
      }
      if (vm.model.lowStockAlert) {
        vm.lowStock = true
      } else {
        vm.lowStock = false
      }
      if (!vm.model.price.wholesale) {
        vm.model.price.wholesale = {
          amount: 0,
          price: 0,
          percentage: false,
        }
      }
      if (vm.model.pictures.imageInput2) {
        vm.imagesModel[0] = vm.model.pictures.imageInput2
        vm.totalImagesModel -= 1
      }
      if (vm.model.pictures.imageInput3) {
        vm.imagesModel[1] = vm.model.pictures.imageInput3
        vm.totalImagesModel -= 1
      }
      if (vm.model.pictures.imageInput4) {
        vm.imagesModel[2] = vm.model.pictures.imageInput4
        vm.totalImagesModel -= 1
      }
      if (vm.model.pictures.imageInput5) {
        vm.imagesModel[3] = vm.model.pictures.imageInput5
        vm.totalImagesModel -= 1
      }
    },
    mounted () {
      const vm = this
      vm.onResize()
      vm.tempLocations = Object.values(vm.model.location) || []
      // const places = vm.field.locations
      // const currentCategories = vm.model.categories || []
      // const model = vm.model
      //
      // vm.populateFields(places, currentCategories, model)
    },
    methods: {
      validateValue () {
        let price
        const vm = this
        if (vm.model.price.wholesale.price) {
          if (vm.model.price.wholesale.percentage) {
            price = vm.model.price.sale - ((+vm.model.price.sale * (+vm.model.price.wholesale.price / 100).toFixed(2)).toFixed(2))
          } else {
            price = +vm.model.price.sale - +vm.model.price.wholesale.price
          }
          if (price < 0) {
            vm.model.price.wholesale.valid = false
            return false
          } else {
            return true
          }
        } else {
          vm.model.price.wholesale.valid = true
          return true
        }
      },
      replaceComma (item, type) {
        if (type === 'lowstock') {
          if (typeof item.lowStockAlert === 'string' && item.lowStockAlert !== '') {
            item.lowStockAlert = parseFloat(item.lowStockAlert.replace(',', '.'))
          }
          return item.lowStockAlert
        } else if (type === 'wholesale') {
          if (typeof item.price.wholesale.amount === 'string' && item.price.wholesale.amount !== '') {
            item.price.wholesale.amount = parseFloat(item.price.wholesale.amount.replace(',', '.'))
          }
          // console.log('entre', item.price.wholesale.amount)
          return item.price.wholesale.amount
        }
      },
      invalidForm (model) {
        const vm = this
        let emptyStock = 0
        for (const key in model.location) {
          if (Object.prototype.hasOwnProperty.call(model.location, key)) {
            const location = model.location[key]
            if ((!location.stock && location.stock !== 0) || location.pricewithouttax === '' || !location.price) {
              emptyStock += 1
            }
          }
        }
        const negativeAmounts = vm.tempLocations.some(item => {
          if (item.stock < 0) {
            return true
          }
        })
        if (emptyStock > 0) {
          return true // disabled save button
        }
        return (vm.lowStock && !model.lowStockAlert) || !model.name || !model.price.buy || !model.price.sale || !model.categories.length || !model.price.wholesale.valid || negativeAmounts
      },
      changeValTaxesModel (item) {
        const vm = this
        // console.log(vm.model.taxesLstProduct)
        // console.log(item.pricewithouttax)
        // console.log(item)
        let valTaxSum = 0
        let valTaxPercentage = 0
        if (vm.model.taxesLstProduct) {
          for (let i = 0; i < vm.model.taxesLstProduct.length; i++) {
            if (vm.model.taxesLstProduct[i].data.percentage) {
              const div = parseFloat(vm.model.taxesLstProduct[i].data.val) / 100
              const val = 1 + div
              let totVal = 0
              if (!item.pricewithouttax) {
                totVal = parseFloat(val) * parseFloat(item.price)
                valTaxPercentage = parseFloat(totVal) - parseFloat(item.price)
              } else {
                totVal = parseFloat(val) * parseFloat(item.pricewithouttax)
                valTaxPercentage = parseFloat(totVal) - parseFloat(item.pricewithouttax)
              }
            } else {
              valTaxPercentage = parseFloat(vm.model.taxesLstProduct[i].data.val)
            }
            valTaxSum = (parseFloat(valTaxSum) + parseFloat(valTaxPercentage)).toFixed(2)
          }
        }
        if (!item.pricewithouttax) {
          item.pricewithouttax = parseFloat(item.price)
        }
        item.price = (parseFloat(item.pricewithouttax) + parseFloat(valTaxSum)).toFixed(2)
        item.taxes = vm.model.taxesLstProduct
        /* for (let i = 0; i < vm.tempLocations.length; i++) {
          if (vm.tempLocations[i].id === item.id) {
            vm.tempLocations[i].price = (parseFloat(item.pricewithouttax) + parseFloat(valTaxSum)).toFixed(2)
            vm.tempLocations[i].taxes = vm.model.taxesLstProduct
          }
        } */
        vm.$forceUpdate()
      },
      changeValTaxes () {
        // console.log(this.model.taxesLstProduct)
        const vm = this
        let valTaxSum = 0
        let valTaxPercentage = 0
        if (vm.model.taxesLstProduct) {
          for (let i = 0; i < vm.model.taxesLstProduct.length; i++) {
            if (vm.model.taxesLstProduct[i].data.percentage) {
              const div = parseFloat(vm.model.taxesLstProduct[i].data.val) / 100
              // console.log('div', div)
              const val = 1 + div
              let totVal = 0
              if (!vm.model.price.salewithouttax) {
                totVal = parseFloat(val) * parseFloat(vm.model.price.sale)
                valTaxPercentage = parseFloat(totVal) - parseFloat(vm.model.price.sale)
              } else {
                totVal = parseFloat(val) * parseFloat(vm.model.price.salewithouttax)
                valTaxPercentage = parseFloat(totVal) - parseFloat(vm.model.price.salewithouttax)
              }
            } else {
              valTaxPercentage = parseFloat(vm.model.taxesLstProduct[i].data.val)
            }
            valTaxSum = (parseFloat(valTaxSum) + parseFloat(valTaxPercentage)).toFixed(2)
          }
        }
        if (!vm.model.price.salewithouttax) {
          // console.log('crear sale without')
          // vm.model.price.sale = (parseFloat(vm.model.price.salewithouttax) + parseFloat(valTaxSum)).toFixed(2)
          vm.model.price.salewithouttax = parseFloat(vm.model.price.sale)
        }
        vm.model.price.sale = (parseFloat(vm.model.price.salewithouttax) + parseFloat(valTaxSum)).toFixed(2)
        // console.log(vm.model.price)
        if (!vm.changeTaxesValueComputed) {
          // console.log('hola')
          for (let i = 0; i < vm.tempLocations.length; i++) {
            vm.tempLocations[i].pricewithouttax = vm.model.price.salewithouttax
            vm.tempLocations[i].price = vm.model.price.sale
          }
        }
      },
      disableChip (item) {
        try {
          if (this.model.location[item.id]) {
            return !!this.model.location[item.id]
          } return false
        } catch (err) {
          return false
        }
      },
      openCategoryModal () {
        this.$emit('openCategoryModal')
      },
      addRows () {
        this.model.location.unshift(
          {
            name: '',
            stock: 0,
            price: null,

          },
        )
      },
      cancel () {
        this.$emit('cancel')
      },
      async save () {
        const vm = this
        vm.model.kitchenAprobal = vm.kitchenAprobal
        vm.model.tempLocations = vm.tempLocations
        // if (vm.taxesLstProduct) {
        //   vm.model.taxesLstProduct = vm.taxesLstProduct
        // }
        vm.saveLoading = true
        for await (const element of vm.actionsImagesModel) {
          if (element.action === 'add') {
            await vm.handleImageUpload(element.data, element.index + 2, true)
          } else if (element.action === 'delete') {
            if (element.index === 0) {
              vm.model.pictures.imageInput2 = ''
            } else if (element.index === 1) {
              vm.model.pictures.imageInput3 = ''
            } else if (element.index === 2) {
              vm.model.pictures.imageInput4 = ''
            } else if (element.index === 3) {
              vm.model.pictures.imageInput5 = ''
            }
          }
        }
        vm.onSave()
        vm.$forceUpdate()
      },
      pickFile (ref) {
        this.$refs[ref].click()
        this.imageRef = ref
      },
      async uploadToServer (file, numberFile) {
        const vm = this
        const storageRef = firebase.storage().ref()
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        vm.model.id = vm.model.id ? vm.model.id : firebase.database().ref().child(`users/${userId}/inventory`).push().key
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        await storageRef.child(`users/${userId}/inventory/pictures/${vm.model.id}/imageInput${numberFile}`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            if (numberFile === 1) {
              vm.model.pictures.imageInput1 = url
            } else if (numberFile === 2) {
              vm.model.pictures.imageInput2 = url
            } else if (numberFile === 3) {
              vm.model.pictures.imageInput3 = url
            } else if (numberFile === 4) {
              vm.model.pictures.imageInput4 = url
            } else if (numberFile === 5) {
              vm.model.pictures.imageInput5 = url
            }
            vm.$forceUpdate()
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      async handleImageUpload (event, numberFile, alt = false) {
        const vm = this
        let imageFile
        if (alt) {
          imageFile = event
        } else {
          imageFile = event.target.files[0]
        }
        if (!imageFile) return
        if (imageFile.type.includes('image')) {
          // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
          // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

          const options = {
            maxSizeMB: 0.06,
            maxWidthOrHeight: 200,
            useWebWorker: true,
            maxIteration: 14,
          }
          try {
            const compressedFile = await imageCompression(imageFile, options)
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
            if (imageFile.size > compressedFile.size) {
              // console.log('compressed is smaller')
              await vm.uploadToServer(compressedFile, numberFile)
            } else {
              // console.log('original is smaller')
              await vm.uploadToServer(imageFile, numberFile)
            } // if original is smaller
          } catch (error) {
            // console.log(error)
          }
        } else {
          vm.message = 'El archivo subido no es una imagen'
          vm.snackbar = true
        }
      },
      setAudio (audio) {
        this.model.audio = audio
        this.$forceUpdate()
      },
      setImage (ref, image) {
        // console.log(ref)
        this.model.pictures[ref] = image
        // console.log(this.model)
        this.$forceUpdate()
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      addImageToModel (event, isDragAndDrop = false) {
        const vm = this
        let file
        if (!isDragAndDrop) {
          file = event.target.files[0]
        } else {
          file = event
        }
        if (!file) return
        if (file.type.includes('image')) {
          const index = vm.imagesModel.findIndex(el => el === '')
          const item = vm.actionsImagesModel.find(el => el.index === index)
          const index2 = vm.actionsImagesModel.findIndex(el => el.index === index)
          if (item && item.action === 'delete') {
            vm.actionsImagesModel.splice(index2, 1, { index: index, action: 'add', data: file })
          } else {
            vm.actionsImagesModel.push({ index: index, action: 'add', data: file })
          }
          const reader = new FileReader()
          reader.onload = function () {
            const output = document.getElementById(index)
            output.src = reader.result
            vm.imagesModel[index] = reader.result
            vm.$forceUpdate()
          }
          reader.readAsDataURL(file)
          vm.totalImagesModel -= 1
        } else {
          vm.message = 'El archivo subido no es una imagen'
          vm.snackbar = true
        }
      },
      deleteImageModel (index) {
        const vm = this
        // console.log(index)
        vm.imagesModel[index] = ''
        vm.actionsImagesModel.push({ index: index, action: 'delete', data: '' })
        vm.totalImagesModel += 1
        vm.$forceUpdate()
      },
      dragover (event) {
        event.preventDefault()
        const vm = this
        vm.isDragging = true
      },
      dragleave (event) {
        const vm = this
        vm.isDragging = false
      },
      async drop (event) {
        const vm = this
        event.preventDefault()
        /* vm.freeSpaces = 0
        vm.imagesModel.forEach(element => {
          if (element === '') {
            vm.freeSpaces += 1
          }
        }) */
        /* for (let index = 0; index < 1; index++) {
          vm.addImageToModel(event.dataTransfer.files[index], true)
        } */
        vm.addImageToModel(event.dataTransfer.files[0], true)
        vm.isDragging = false
      },
      openImage (img) {
        Swal.fire({
          imageUrl: img,
          imageWidth: 400,
          imageHeight: 400,
          imageAlt: 'Product alternative image',
        })
      },
    },

  }
</script>
<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;

  .product--detail {
      &__title {
        background: rgb(45,180,188);
        background: linear-gradient(90deg, rgba(45,180,188,1) 0%, rgba(87,101,190,1) 100%);
        color: white;
        font-weight: 800;
        border-radius: 5px;
        text-transform: uppercase;
      }

      &__product--name {
        padding-top: 3rem;
        padding-bottom: 4px;
        font-weight: 500;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 1.7rem;
        color: #30b4bb;
        display: inline-block;
      }

      &__info--name {
        font-weight: 500;
        font-weight: 800;
        font-size: 1.6rem;
        color: #696969;
        display: inline-block;

        &__border {
          padding-bottom: 0px !important;
          border: 2px #c9c9c9 solid;
          border-radius: 5px;
          font-size: 1.2rem;
        }
      }

      &__product--img {
        padding-top: 2rem;
        border-radius: 30px;
        &__img {
          left: 50%;
          transform: translate(-50%, 0);
        }

        &__btn {
          top: 1rem;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      &__margin {
        border-bottom: 1px solid #e6e6e6;
      }

      &__info {
        padding-top: 0;
        font-weight: 100;
        font-size: 0.9rem;
        //color: #525252;
        color: #939393;
        display: inline-block;
      }

      &-product__card {
        height: 403;
        width: 302;
        margin-bottom: 24px;
        padding: 12px;
        display: inline-block;
        border-width: 4px;
        border-radius: 25px;
      }
    }

</style>
